<template>
  <el-container class="schedule">
    <el-header class="header-style">
      <el-row style="background-color: #ecf4ff; color: #409eff; margin-bottom: 0.2rem">
        <el-col :span="6">
          <el-tooltip
            :content="
              '总数：' +
              counts.total +
              '，服务中：' +
              counts.in_service +
              '，已完成：' +
              counts.service_complete
            "
          >
            <div class="count-style">
              <span>总数：{{ pageOption.total }}</span>
              <span class="count">服务中：{{ counts.in_service }}</span>
              <span class="count">已完成：{{ counts.service_complete }}</span>
            </div>
          </el-tooltip>
        </el-col>
        <el-col :span="12" :offset="6">
          <el-tooltip
            :content="
              '核名：' +
              counts.verifierCount +
              '，网报：' +
              counts.declareCount +
              '，网签：' +
              counts.signatoryCount +
              '，领取执照：' +
              counts.licenseCount +
              '，刻章：' +
              counts.chapterCount +
              '，材料交接：' +
              counts.materialCount
            "
          >
            <div class="count-style">
              <span>核名：{{ counts.verifierCount }}</span>
              <span class="count">网报：{{ counts.declareCount }}</span>
              <span class="count">网签：{{ counts.signatoryCount }}</span>
              <span class="count">领取执照：{{ counts.licenseCount }}</span>
              <span class="count">刻章：{{ counts.chapterCount }}</span>
              <span class="count">材料交接：{{ counts.materialCount }}</span>
            </div>
          </el-tooltip>
        </el-col>
      </el-row>
      <el-row class="mb-10">
        <el-col :span="5">
          <el-input
            v-model="searchArr.order_num"
            size="mini"
            placeholder="输入订单编号搜素"
            @input="handleOrderNumChange"
            clearable
          ></el-input>
        </el-col>
        <el-col :span="5">
          <el-select
            v-model="searchArr.company_id"
            filterable
            remote
            reserve-keyword
            placeholder="请输入公司名称筛选公司"
            size="mini"
            clearable
            :remote-method="searchRemoteCompanyMethod"
            :loading="searchLoading"
            @change="handleSearchCompanyChange"
          >
            <el-option
              v-for="searchCompany in searchCompanies"
              :key="searchCompany.id"
              :label="searchCompany.company_name"
              :value="searchCompany.id"
            >
            </el-option>
          </el-select>
        </el-col>
        <!-- <el-col :span="3" :offset="10">
        <el-button type="primary" size="mini" @click="findAdviserUpdateToBusiness">批量关联顾问为业务员</el-button>
      </el-col> -->
        <el-col :span="1" :offset="13">
          <el-tooltip
            class="item"
            effect="dark"
            content="选择条件导出公司名称"
            placement="top"
          >
            <el-button type="warning" size="mini" @click="exportTableData"
              >导出</el-button
            >
          </el-tooltip>
        </el-col>
      </el-row>

      <!-- <el-divider content-position="left">公司注册进度</el-divider> -->
      <el-collapse v-model="activeOpen" accordion>
        <el-collapse-item title="高级筛选" name="1">
          <div style="padding: 10px">
            <el-row class="mb-20 search-row">
              <el-col :span="2"><span>服务状态</span></el-col>
              <el-col :span="6">
                <el-select
                  v-model="searchArr.service_status"
                  placeholder="请选择"
                  size="mini"
                  clearable
                >
                  <el-option :value="3" label="服务中"></el-option>
                  <el-option :value="4" label="服务完成"></el-option>
                  <el-option :value="6" label="服务停止"></el-option>
                </el-select>
              </el-col>
              <el-col :span="2" :offset="1"><span>沟通顾问</span></el-col>
              <el-col :span="5">
                <el-cascader
                  v-model="searchArr.consultant"
                  placeholder="请选择沟通顾问"
                  :options="personnel"
                  size="mini"
                  :props="{ expandTrigger: 'hover', multiple: true, emitPath: false }"
                  clearable
                  filterable
                  :filter-method="filterOptions"
                >
                </el-cascader>
              </el-col>
              <el-col :span="2" :offset="1"><span>办理节点</span></el-col>
              <el-col :span="5">
                <el-select
                  v-model="searchArr.handNode"
                  placeholder="请选择"
                  size="mini"
                  clearable
                >
                  <el-option :value="7" label="信息表整理"></el-option>
                  <el-option :value="1" label="核名"></el-option>
                  <el-option :value="2" label="网报"></el-option>
                  <el-option :value="3" label="网签"></el-option>
                  <el-option :value="4" label="领取执照"></el-option>
                  <el-option :value="5" label="刻章"></el-option>
                  <el-option :value="6" label="材料交接"></el-option>
                </el-select>
              </el-col>
            </el-row>
            <el-row class="mb-20 search-row">
              <el-col :span="2"><span>行业特点</span></el-col>
              <el-col :span="6">
                <el-select
                  v-model="searchArr.feature"
                  filterable
                  placeholder="请选择"
                  size="mini"
                  clearable
                >
                  <el-option
                    v-for="item in features"
                    :key="item.industry_id"
                    :label="item.industry_name"
                    :value="item.industry_id"
                  ></el-option>
                </el-select>
              </el-col>
              <el-col :span="2" :offset="1"><span>注册类型</span></el-col>
              <el-col :span="5">
                <el-select
                  v-model="searchArr.actual_reg_type"
                  placeholder="请选择"
                  size="mini"
                  clearable
                >
                  <el-option
                    v-for="item in regTypes"
                    :key="item.reg_type_id"
                    :label="item.reg_type_name"
                    :value="item.reg_type_id"
                  ></el-option>
                </el-select>
              </el-col>
              <el-col :span="2" :offset="1"><span>服务人员</span></el-col>
              <el-col :span="5">
                <el-cascader
                  v-model="searchArr.operator"
                  placeholder="请选择服务人员"
                  :options="personnel"
                  size="mini"
                  :props="{ expandTrigger: 'hover', multiple: true, emitPath: false }"
                  clearable
                  filterable
                  :filter-method="filterOptions"
                >
                </el-cascader>
              </el-col>
            </el-row>
            <el-row class="mb-20 search-row">
              <el-col :span="2"><span>订单来源</span></el-col>
              <el-col :span="6">
                <el-select
                  v-model="searchArr.platform"
                  filterable
                  placeholder="请选择"
                  clearable
                  size="mini"
                  multiple
                  @click.native="getFrom"
                >
                  <el-option
                    v-for="item in fromOptions"
                    :key="item.id"
                    :value="item.id"
                    :label="item.name"
                  >
                  </el-option>
                </el-select>
              </el-col>
              <el-col :span="2" :offset="1"><span>园区</span></el-col>
              <el-col :span="5">
                <el-select
                  v-model="searchArr.park"
                  filterable
                  placeholder="请选择"
                  clearable
                  size="mini"
                >
                  <el-option
                    v-for="option in parks"
                    :key="option.id"
                    :label="option.areaName"
                    :value="option.id"
                  >
                  </el-option>
                </el-select>
              </el-col>
              <el-col :span="2" :offset="1"><span>核名时间</span></el-col>
              <el-col :span="5">
                <el-date-picker
                  size="mini"
                  v-model="searchArr.verifier_at"
                  type="daterange"
                  align="right"
                  unlink-panels
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd"
                  :picker-options="ysyTypeInPickerOptions"
                >
                </el-date-picker>
              </el-col>
            </el-row>

            <el-row class="mb-20 search-row">
              <el-col :span="2"><span>网报时间</span></el-col>
              <el-col :span="6">
                <el-date-picker
                  size="mini"
                  v-model="searchArr.declare_at"
                  type="daterange"
                  align="right"
                  unlink-panels
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd"
                  :picker-options="ysyTypeInPickerOptions"
                >
                </el-date-picker>
              </el-col>
              <el-col :span="2" :offset="1"><span>网签时间</span></el-col>
              <el-col :span="5">
                <el-date-picker
                  size="mini"
                  v-model="searchArr.signatory_at"
                  type="daterange"
                  align="right"
                  unlink-panels
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd"
                  :picker-options="ysyTypeInPickerOptions"
                >
                </el-date-picker>
              </el-col>
              <el-col :span="2" :offset="1"><span>领执照时间</span></el-col>
              <el-col :span="5">
                <el-date-picker
                  size="mini"
                  v-model="searchArr.license_at"
                  type="daterange"
                  align="right"
                  unlink-panels
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd"
                  :picker-options="ysyTypeInPickerOptions"
                >
                </el-date-picker>
              </el-col>
            </el-row>

            <el-row class="mb-20 search-row">
              <el-col :span="2"><span>材料交接时间</span></el-col>
              <el-col :span="6">
                <el-date-picker
                  size="mini"
                  v-model="searchArr.material_at"
                  type="daterange"
                  align="right"
                  unlink-panels
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd"
                  :picker-options="ysyTypeInPickerOptions"
                >
                </el-date-picker>
              </el-col>
              <el-col :span="2" :offset="1"><span>核名状态</span></el-col>
              <el-col :span="5">
                <el-select
                  v-model="searchArr.verification_state"
                  placeholder="请选择"
                  size="mini"
                  clearable
                >
                  <el-option :value="0" label="未通过"></el-option>
                  <el-option :value="1" label="通过"></el-option>
                </el-select>
              </el-col>
              <el-col :span="2" :offset="1"><span>实际注册类型</span></el-col>
              <el-col :span="5">
                <el-select
                  v-model="searchArr.realType"
                  filterable
                  remote
                  reserve-keyword
                  placeholder="请选择实际注册类型"
                  size="mini"
                  clearable
                  style="width: 100%"
                  @click.native="getRealTypeList"
                >
                  <el-option label="没有实际注册类型" value="not"> </el-option>
                  <el-option
                    v-for="i in RealTypeList"
                    :key="i.reg_type_id"
                    :label="i.reg_type_name"
                    :value="i.reg_type_id"
                  >
                  </el-option>
                </el-select>
              </el-col>
            </el-row>
            <el-row class="mb-20 search-row">
              <el-col :span="2"><span>派单时间</span></el-col>
              <el-col :span="6">
                <el-date-picker
                  v-model="dispatch"
                  type="datetimerange"
                  align="right"
                  unlink-panels
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  :picker-options="typeInPickerOptions"
                  :default-time="['00:00:00', '23:59:59']"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  size="mini"
                  @change="goToGetResult"
                >
                </el-date-picker>
              </el-col>
              <el-col :span="2" :offset="1"><span>执照扫描件</span></el-col>
              <el-col :span="5">
                <el-select
                  v-model="searchArr.hasConductFile"
                  placeholder="请选择"
                  size="mini"
                  clearable
                >
                  <el-option value="y" label="有"></el-option>
                  <el-option :value="null" label="不限制"></el-option>
                </el-select>
              </el-col>
            </el-row>

            <el-row style="text-align: center">
              <el-button type="primary" size="mini" @click="handleASearSub"
                >查询</el-button
              >
              <el-button type="danger" size="mini" @click="handleASearClear"
                >清除</el-button
              >
            </el-row>
          </div>
        </el-collapse-item>
        <el-collapse-item title="数据统计" name="2">
          <el-row :gutter="24">
            <el-col
              :xs="24"
              :sm="21"
              :md="14"
              :lg="8"
              style="margin-bottom: 0.2rem; font-size: medium"
              :span="6"
              v-for="(item, key, index) in HeaderList[0]"
              :key="index"
            >
              <span>{{ Object.keys(item).join(":") }}:</span>
              <span style="color: #e6a23c">{{ Object.values(item).join("") }}</span>
              <span style="margin-left: 0.1rem">所占百分比：</span>
              <span style="color: #67c23a">{{
                (
                  (parseInt(Object.values(item).join("")) / pageOption.total) *
                  100
                ).toFixed(2) + "%"
              }}</span>
            </el-col>
            <el-col
              :xs="24"
              :sm="21"
              :md="14"
              :lg="8"
              :span="6"
              style="margin-bottom: 0.2rem; font-size: medium"
            >
              <span>无实际注册类型:</span>
              <span style="color: #e6a23c">{{ pageOption.total - HeaderList[1] }}</span>
              <span style="margin-left: 0.1rem">所占百分比：</span>
              <span style="color: #67c23a">{{
                (((pageOption.total - HeaderList[1]) / pageOption.total) * 100).toFixed(
                  2
                ) + "%"
              }}</span>
            </el-col>
          </el-row>
        </el-collapse-item>
      </el-collapse>
    </el-header>

    <el-main class="main-style">
      <el-table
        height="calc(100vh - 346px)"
        :data="orders"
        size="medium"
        style="width: 100%"
        v-cloak
        border
      >
        <el-table-column fixed label="订单编号" width="190">
          <template slot-scope="scope">
            <el-link
              class="ellipsis-link"
              type="primary"
              @click="handleOrderInfo(scope.row.id, scope.row.order_num)"
              >{{ scope.row.order_num }}</el-link
            >
          </template>
        </el-table-column>
        <el-table-column fixed label="服务状态" width="120">
          <template slot-scope="scope">
            <div v-if="scope.row.service_status === '服务中'">
              <span class="dot" style="background-color: #88d023"></span>
              <el-link disabled>{{ scope.row.service_status }}</el-link>
            </div>
            <div v-else>
              <span class="dot" style="background-color: #ff8839"></span>
              <el-link disabled>{{ scope.row.service_status }}</el-link>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="信息表状态" width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.doc_status === 0">暂无</span>
            <span v-if="scope.row.doc_status === 1">合格</span>
            <span v-if="scope.row.doc_status === 2">不合格</span>
          </template>
        </el-table-column>
        <el-table-column label="订单来源" prop="platform" width="100">
          <template slot-scope="scope">
              <span class="ellipsis-link">
                {{ scope.row.platform }}
              </span>
          </template>
        </el-table-column>
        <el-table-column label="顾问">
          <template slot-scope="scope">
            <span v-if="scope.row.advisor">{{ scope.row.advisor.username }}</span>
          </template>
        </el-table-column>
        <el-table-column
          v-for="(item, index) in col"
          :label="item.label"
          :key="index"
          :width="item.width"
        >
          <template slot-scope="scope">
            <!-- <el-tooltip
              v-if="item.prop === 'customer_phone'"
              :content="scope.row.customer_phone"
              placement="top"
            >
              <!== <span class="count-style">{{
                scope.row.customer_phone
                  ? scope.row.customer_phone.substring(0, 5) + "..."
                  : ""
              }}</span> ==>
            </el-tooltip> -->
            <phone-com v-if="item.prop === 'customer_phone' && scope.row.customer_phone"
                  :comPhone="scope.row.customer_phone"
                  :vagaryPhone="scope.row.vagary_phone_custome"
                  style="display: inline-block"
                />
            <!-- <el-tooltip
              v-else-if="item.prop === 'corporate_phone'"
              :content="scope.row.corporate_phone"
              placement="top"
            >
              <span class="count-style">{{
                scope.row.corporate_phone
                  ? scope.row.corporate_phone.substring(0, 5) + "..."
                  : ""
              }}</span>
            </el-tooltip> -->
            <phone-com v-else-if="item.prop === 'corporate_phone' && scope.row.corporate_phone"
                  :comPhone="scope.row.corporate_phone"
                  :vagaryPhone="scope.row.vagary_phone_corporate"
                  style="display: inline-block"
                />
            <el-tooltip
              v-else-if="item.prop === 'company'"
              :content="scope.row.company"
              placement="top"
            >
              <span class="count-style"
                >{{ scope.row.company ? scope.row.company.substring(0, 6) + "..." : "" }}
                <el-tooltip
                  v-if="scope.row.company"
                  class="item"
                  effect="dark"
                  content="复制"
                  placement="bottom"
                  ><i
                    class="el-icon-document-copy"
                    style="margin-left: 0.1rem; cursor: pointer"
                    @click="copySome(scope.row.company)"
                  ></i
                ></el-tooltip>
              </span>
            </el-tooltip>
            <div v-else :content="scope.row[item.prop]" placement="top">
              <span class="count-style">{{ scope.row[item.prop] }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="160">
          <template slot-scope="scope">
            <el-tooltip class="item" effect="dark" content="办理信息" placement="top">
              <el-button
                :type="scope.row.service_status === '服务完成' ? 'success' : 'info'"
                :icon="
                  scope.row.service_status === '服务完成'
                    ? 'el-icon-check'
                    : 'el-icon-edit-outline'
                "
                size="mini"
                circle
                @click="handleConduct(scope.$index, scope.row)"
                :disabled="scope.row.order_status === '已退款'"
              ></el-button>
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              content="企业微信群聊天记录"
              placement="top"
            >
              <el-button
                type="warning"
                :disabled="scope.row.wx_work_chat_com ? false : true"
                @click="
                  handleWxChatOpen(scope.row.wx_work_chat_com, scope.row.company_name)
                "
                size="mini"
                icon="el-icon-s-comment"
                circle
              ></el-button>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="电话联系记录" placement="top">
              <el-button
                type="primary"
                size="mini"
                icon="el-icon-phone-outline"
                circle
                @click="handCallLogsOpen(scope.row)"
              ></el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
    </el-main>

    <el-footer class="footer-style">
      <el-pagination
        background
        class="tr mt-10"
        layout="sizes, total, prev, pager, next, jumper"
        :hide-on-single-page="false"
        :current-page="search ? pageOption.searchCurrentPage : pageOption.currentPage"
        :page-sizes="[10, 20, 30, 50, 100, 500]"
        :page-size="pageOption.pageSize"
        :total="pageOption.total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </el-footer>

    <el-drawer
      title="企业微信聊天记录"
      :visible.sync="wxChatDrawer"
      direction="rtl"
      :before-close="handleWxChatBeforeClose"
      size="50%"
    >
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <el-row>
          <wx-work-chat
            :chatId="wxWorkChatId"
            :chatName="wxWorkchatCompany"
          ></wx-work-chat>
        </el-row>
      </div>
    </el-drawer>
    <el-drawer
      :title="'办理信息： ' + out_trade_num"
      :visible.sync="conductDrawer"
      direction="rtl"
      custom-class="AIdrawer"
      :before-close="handleConductClose"
      size="50%"
    >
    <div class="drawer-title" slot="title">办理信息： {{ out_trade_num }}</div>
      <div class="m-tabs-content">
        <el-row>
          <el-card shadow="always">
            <div slot="header" class="clearfix">
              <el-row style="margin-bottom: 0; padding-right: 16px">
                <el-col :span="18"><span>公司信息表整理</span></el-col>
                <el-col :span="6">
                  <el-button type="primary" size="mini" @click="handelAddFeiShuDoc"
                    >{{ conductForm.com_doc_url ? "修改" : "添加" }}
                  </el-button>
                  <el-badge :value="'测试'" class="item">
                    <el-button type="primary" size="mini" @click="handelEditFlow"
                      >流程</el-button
                    >
                  </el-badge>
                </el-col>
              </el-row>
            </div>
            <div>
              <el-row v-if="conductForm.com_doc_url">
                <el-link class="custom-link" type="primary" @click="showDoc"
                  ><i class="el-icon-s-order custom-link"></i>查看文档</el-link
                >
              </el-row>
              <el-row>
                <el-col :span="12">
                  <span>整理人：{{ conductForm.organizer_name }}</span>
                </el-col>
                <el-col :span="12">
                  <span>整理时间：{{ conductForm.organizer_at }}</span>
                </el-col>
              </el-row>
              <el-row style="margin-top: 0.2rem">
                <el-col :span="12">
                  <span>实际注册类型:</span>
                  <span style="margin-left: 0.2rem">{{ realType }}</span>
                </el-col>
                <el-col :span="12">
                  <span>信息表是否合格:</span>
                  <span v-if="conductForm.doc_status === 1">合格</span>
                  <span style="color: red" v-else-if="conductForm.doc_status === 2"
                    >不合格</span
                  >
                  <span v-else>历史信息表，未进行检测</span>
                </el-col>
              </el-row>
            </div>
          </el-card>
        </el-row>

        <el-row>
          <el-card shadow="always">
            <div slot="header" class="clearfix">
              <span>信息表检查</span>
            </div>
            <div>
              <el-row>
                <el-col :span="6" class="m-label">信息表是否合格：</el-col>
                <el-col :span="12">
                  <el-radio-group
                    v-model="info_excel"
                    @change="
                      SaveChangeMethods(conductForm.id, 'doc_status', '信息表是否合格')
                    "
                    size="small"
                  >
                    <el-radio-button
                      label="合格"
                      :class="{ 'qualified-radio': conductForm.doc_status == 1 }"
                      >合格</el-radio-button
                    >
                    <el-radio-button label="不合格">不合格</el-radio-button>
                  </el-radio-group>
                </el-col>
              </el-row>

              <el-row v-if="reason_for_fail_show">
                <el-col :span="6" class="m-label">不合格理由：</el-col>
                <el-col :span="18">
                  <el-input
                    v-model="reason_for_fail"
                    type="textarea"
                    placeholder="请填写不合格的理由，此理由将通过企业微信通知发送给当前顾问"
                  ></el-input>
                </el-col>
              </el-row>
              <el-row v-if="reason_for_fail_show">
                <el-col :span="2" :offset="6">
                  <el-button
                    type="primary"
                    size="mini"
                    @click="
                      handleUpdateDocStatus(
                        conductForm.id,
                        'doc_status',
                        conductForm.consultant
                      )
                    "
                    >提交
                  </el-button>
                </el-col>
              </el-row>

              <el-row>
                <el-card shadow="always">
                  <div slot="header" class="clearfix">
                    <span>信息表检测记录</span>
                  </div>
                  <div>
                    <el-row>
                      <el-timeline>
                        <el-timeline-item
                          v-for="(item, index) in conductForm.docHandleRecord"
                          :key="index"
                          :timestamp="item.created_at"
                        >
                          <span
                            v-if="
                              item.reason_for_fail === '' || item.reason_for_fail === null
                            "
                            v-html="highlightQualify(item.content)"
                          ></span>
                          <span v-else v-html="item.content"></span>
                          <br />
                          <br />
                          <span
                            v-if="
                              item.reason_for_fail !== '' && item.reason_for_fail != null
                            "
                            style="color: red"
                            >不合格理由：{{ item.reason_for_fail }}</span
                          >
                        </el-timeline-item>
                      </el-timeline>
                    </el-row>
                  </div>
                </el-card>
              </el-row>
            </div>
          </el-card>
        </el-row>

        <div v-show="conductForm.doc_status === 1">
          <el-row>
            <el-card shadow="always">
              <div slot="header" class="clearfix">
                <span>网报</span>
              </div>
              <div>
                <el-row>
                  <el-col :span="4" class="m-label">人员</el-col>
                  <el-col :span="7">
                    <el-cascader
                      v-model="conductForm.declarer"
                      placeholder="请选择人员"
                      :options="personnel"
                      size="mini"
                      :props="{ expandTrigger: 'hover', emitPath: false }"
                      clearable
                      filterable
                      @change="
                        handelPeople(
                          'declarer',
                          'declarer_name',
                          '网报人员',
                          'conductForm'
                        )
                      "
                      :filter-method="filterOptions"
                    >
                    </el-cascader>
                  </el-col>
                  <el-col :span="4" :offset="2" class="m-label">时间</el-col>
                  <el-col :span="7">
                    <el-date-picker
                      v-model="conductForm.declare_at"
                      type="date"
                      placeholder="选择日期"
                      :size="inputSize"
                      value-format="yyyy-MM-dd"
                      @change="handelPickerChange('declare_at', '网报时间')"
                    ></el-date-picker>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="4" class="m-label">区域</el-col>
                  <el-col :span="7">
                    <el-select
                      v-model="conductForm.area"
                      placeholder="请选择"
                      clearable
                      size="mini"
                      @change="handleAreaSub('area', '区域', 'conductForm')"
                    >
                      <el-option
                        v-for="item in areas"
                        :label="item.areaName"
                        :value="item.id"
                        :key="item.id"
                      ></el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="4" :offset="2" class="m-label">园区</el-col>
                  <el-col :span="7">
                    <el-select
                      v-model="conductForm.park"
                      placeholder="请选择"
                      clearable
                      size="mini"
                      @change="handleParkChange('park', '园区', 'conductForm')"
                    >
                      <el-option
                        v-for="item in changeParks"
                        :label="item.areaName"
                        :value="item.id"
                        :key="item.id"
                      ></el-option>
                    </el-select>
                  </el-col>
                </el-row>
              </div>
            </el-card>
          </el-row>
          <el-row>
            <el-card shadow="always">
              <div slot="header" class="clearfix">
                <span>核名</span>
              </div>
              <div>
                <el-row>
                  <el-col :span="4" class="m-label">核名名称</el-col>
                  <el-col :span="7">
                    <el-input
                      v-model="conductForm.verification_company_name"
                      :size="inputSize"
                      clearable
                      @blur.native.capture="
                        handleConductChange('verification_company_name', '核名名称')
                      "
                      @clear="
                        handleConductChange('verification_company_name', '核名名称')
                      "
                    ></el-input>
                  </el-col>
                  <el-col :span="4" :offset="2" class="m-label">人员</el-col>
                  <el-col :span="7">
                    <el-cascader
                      v-model="conductForm.verifier"
                      placeholder="请选择人员"
                      :options="personnel"
                      size="mini"
                      :props="{ expandTrigger: 'hover', emitPath: false }"
                      clearable
                      filterable
                      @change="
                        handelPeople(
                          'verifier',
                          'verifier_name',
                          '核名人员',
                          'conductForm'
                        )
                      "
                      :filter-method="filterOptions"
                    >
                    </el-cascader>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="4" class="m-label">时间</el-col>
                  <el-col :span="7">
                    <el-date-picker
                      v-model="conductForm.verifier_at"
                      type="date"
                      placeholder="选择日期"
                      :size="inputSize"
                      value-format="yyyy-MM-dd"
                      @change="handelPickerChange('verifier_at', '核名时间')"
                    ></el-date-picker>
                  </el-col>
                  <el-col :span="4" :offset="2" class="m-label">核名状态</el-col>
                  <el-col :span="7">
                    <el-tooltip :content="conductForm.verification_state" placement="top">
                      <el-switch
                        v-model="conductForm.verification_state"
                        active-color="#5789F4"
                        inactive-color="#dcdfe6"
                        active-value="通过"
                        inactive-value="未通过"
                        @change="handelSaveChange('verification_state', '核名状态')"
                      >
                      </el-switch>
                    </el-tooltip>
                  </el-col>
                </el-row>
              </div>
            </el-card>
          </el-row>
          <el-row>
            <el-card shadow="always">
              <div slot="header" class="clearfix"><span>网签</span></div>
              <div>
                <el-row>
                  <el-col :span="4" class="m-label">人员</el-col>
                  <el-col :span="7">
                    <el-cascader
                      v-model="conductForm.signatory"
                      placeholder="请选择人员"
                      :options="personnel"
                      size="mini"
                      :props="{ expandTrigger: 'hover', emitPath: false }"
                      clearable
                      filterable
                      @change="
                        handelPeople(
                          'signatory',
                          'signatory_name',
                          '网签人员',
                          'conductForm'
                        )
                      "
                      :filter-method="filterOptions"
                    >
                    </el-cascader>
                  </el-col>
                  <el-col :span="4" :offset="2" class="m-label">时间</el-col>
                  <el-col :span="7">
                    <el-date-picker
                      v-model="conductForm.signatory_at"
                      type="date"
                      placeholder="选择日期"
                      :size="inputSize"
                      value-format="yyyy-MM-dd"
                      @change="handelPickerChange('signatory_at', '网签时间')"
                    ></el-date-picker>
                  </el-col>
                </el-row>
              </div>
            </el-card>
          </el-row>
          <el-row>
            <el-card shadow="always">
              <div slot="header" class="clearfix"><span>执照</span></div>
              <el-row>
                <el-col :span="4" class="m-label">人员</el-col>
                <el-col :span="7">
                  <el-cascader
                    v-model="conductForm.licensee"
                    placeholder="请选择人员"
                    :options="personnel"
                    size="mini"
                    :props="{ expandTrigger: 'hover', emitPath: false }"
                    clearable
                    filterable
                    @change="
                      handelPeople(
                        'licensee',
                        'licensee_name',
                        '执照领取人员',
                        'conductForm'
                      )
                    "
                    :filter-method="filterOptions"
                  >
                  </el-cascader>
                </el-col>
                <el-col :span="4" :offset="2" class="m-label">领执照时间</el-col>
                <el-col :span="7">
                  <el-date-picker
                    v-model="conductForm.license_at"
                    type="date"
                    placeholder="选择日期"
                    :size="inputSize"
                    value-format="yyyy-MM-dd"
                    @change="handelPickerChange('license_at', '执照领取时间')"
                  ></el-date-picker>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="4" class="m-label">公司名称</el-col>
                <el-col :span="7">
                  <el-select
                    v-model="conductForm.company_id"
                    filterable
                    remote
                    reserve-keyword
                    placeholder="输入公司"
                    size="mini"
                    clearable
                    :remote-method="remoteMethod"
                    :loading="loading"
                    @change="handleCompanyChange()"
                  >
                    <el-option
                      v-for="company in companies"
                      :key="company.company_name + company.id"
                      :label="company.company_name"
                      :value="company.id"
                    >
                    </el-option>
                  </el-select>
                </el-col>
                <el-col :span="4" :offset="2" class="m-label">公司成立时间</el-col>
                <el-col :span="7">
                  <el-date-picker
                    v-model="conductForm.established_at"
                    type="date"
                    placeholder="选择日期"
                    :size="inputSize"
                    value-format="yyyy-MM-dd"
                    @change="handelPickerChange('established_at', '公司成立时间')"
                  ></el-date-picker>
                </el-col>
              </el-row>
              <el-row>
                <el-card shadow="always">
                  <div slot="header" class="clearfix">
                    <span>执照扫描件</span>
                  </div>
                  <el-row>
                    <el-upload
                      :action="actionHost + '/api/upload/tyc/annex'"
                      :headers="uploadHeader"
                      :data="{ id: conductForm.id, type: 2 }"
                      :on-success="handleConductAnnexSuccess"
                      :on-preview="handleConductPreview"
                      :on-remove="handleConductRemove"
                      :file-list="conductFileList"
                    >
                      <el-link type="primary">上传</el-link>
                    </el-upload>
                  </el-row>
                </el-card>
              </el-row>
            </el-card>
          </el-row>
          <el-row v-show="conductForm.chapter === '是'">
            <el-card shadow="always">
              <div slot="header" class="clearfix"><span>刻章</span></div>
              <div>
                <el-row>
                  <el-col :span="4" class="m-label">人员</el-col>
                  <el-col :span="7">
                    <el-cascader
                      v-model="conductForm.chapter_pr"
                      placeholder="请选择人员"
                      :options="personnel"
                      size="mini"
                      :props="{ expandTrigger: 'hover', emitPath: false }"
                      clearable
                      filterable
                      @change="
                        handelPeople(
                          'chapter_pr',
                          'chapter_name',
                          '刻章人员',
                          'conductForm'
                        )
                      "
                      :filter-method="filterOptions"
                    >
                    </el-cascader>
                  </el-col>
                  <el-col :span="4" :offset="2" class="m-label">时间</el-col>
                  <el-col :span="7">
                    <el-date-picker
                      v-model="conductForm.chapter_at"
                      type="date"
                      placeholder="选择日期"
                      :size="inputSize"
                      value-format="yyyy-MM-dd"
                      @change="handelPickerChange('chapter_at', '刻章时间')"
                    ></el-date-picker>
                  </el-col>
                </el-row>
              </div>
            </el-card>
          </el-row>
          <el-row>
            <el-card shadow="always">
              <div slot="header" class="clearfix"><span>材料交接</span></div>
              <el-row>
                <el-col :span="4" class="m-label">人员</el-col>
                <el-col :span="7">
                  <el-cascader
                    v-model="conductForm.material"
                    placeholder="请选择人员"
                    :options="personnel"
                    size="mini"
                    :props="{ expandTrigger: 'hover', emitPath: false }"
                    clearable
                    filterable
                    @change="
                      handelPeople(
                        'material',
                        'material_name',
                        '材料交接人员',
                        'conductForm'
                      )
                    "
                    :filter-method="filterOptions"
                  >
                  </el-cascader>
                </el-col>
                <el-col :span="4" :offset="2" class="m-label">时间</el-col>
                <el-col :span="7">
                  <el-date-picker
                    v-model="conductForm.material_at"
                    type="date"
                    placeholder="选择日期"
                    :size="inputSize"
                    value-format="yyyy-MM-dd"
                    @change="handelPickerChange('material_at', '材料交接时间')"
                  ></el-date-picker>
                </el-col>
              </el-row>
              <el-row>
                <el-card shadow="always">
                  <div slot="header" class="clearfix"><span>附件</span></div>
                  <el-row>
                    <el-upload
                      :action="actionHost + '/api/upload/tyc/annex'"
                      :headers="uploadHeader"
                      :data="{ id: conductForm.id, type: 3 }"
                      :on-success="handleMaterialSuccess"
                      :on-preview="handleMaterialPreview"
                      :on-remove="handleMaterialRemove"
                      :file-list="materialFlieList"
                    >
                      <el-link type="primary">上传</el-link>
                    </el-upload>
                  </el-row>
                </el-card>
              </el-row>
            </el-card>
          </el-row>
          <el-row>
            <el-card shadow="always">
              <div slot="header" class="clearfix"><span>办理进度</span></div>
              <el-row>
                <el-col class="m-label">
                  <el-button
                    v-if="conductForm.service_status === '服务完成'"
                    type="info"
                    size="mini"
                    disabled
                    >已完成</el-button
                  >
                  <el-button
                    v-else
                    type="primary"
                    size="mini"
                    @click="handleConductComplete"
                    >完成</el-button
                  >
                </el-col>
              </el-row>
            </el-card>
          </el-row>
        </div>
      </div>
    </el-drawer>
    <el-drawer
      title="电话联系记录"
      :visible.sync="callLogsDrawer"
      direction="rtl"
      :before-close="handleCallLogsBeforeClose"
      size="50%"
    >
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <el-row>
          <call-logs
            :company="company"
            :phone="callPhone"
            :phone1="callPhone1"
            :phone2="callPhone2"
            :phone3="callPhone3"
          ></call-logs>
        </el-row>
      </div>
    </el-drawer>
    <el-drawer
    :title="'订单信息： ' + out_trade_num"
      :visible.sync="orderInfoVisible"
      direction="rtl"
      custom-class="AIdrawer"
      size="50%"
      :before-close="handleOrderInfoClose"
    >
    <div class="drawer-title" slot="title">订单信息： {{ out_trade_num }}</div>
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <order-info :orderId="orderInfoId" :checkType="serviceCheckType"></order-info>
      </div>
    </el-drawer>
    <el-dialog
      title="设置文档地址"
      :visible.sync="feiShuDocVisible"
      width="40%"
      :before-close="handleShuDocClose"
    >
      <el-input
        v-model="conductForm.com_doc_url"
        :size="inputSize"
        clearable
        @blur.native.capture="
          handleConductChange('com_doc_url', '公司信息表地址', conductForm.customer_phone)
        "
        @clear="handleConductChange('com_doc_url', '公司信息表地址')"
      ></el-input>
    </el-dialog>
    <el-dialog title="导入信息" :visible.sync="dialogFormVisible">
      <div style="padding: 0.5rem 1rem">
        <p style="color: #409eff; font-size: large">
          本次共查询数据<strong>{{ importNum }}</strong
          >条
        </p>
        <p style="color: #67c23a; font-size: small; margin-top: 0.2rem">
          完成修改<strong>{{ updatedBusinessNum }}</strong
          >条
        </p>
      </div>
      <div slot="footer" class="dialog-footer">
        <!-- <el-button size="mini" @click="dialogFormVisible = false"
          >重新导入</el-button
        > -->
        <el-button type="primary" size="mini" @click="dialogFormVisible = false"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </el-container>
</template>

<script>
import WxWorkChat from "common/WxWorkChat";
import CallLogs from "common/CallLogs";
import OrderInfo from "common/OrderInfo";
import { fscDate } from "../../../static/mixins/fastChooseDate";
import { getQiyehuoAdmin, runQiyehuoAdmin } from "../../lib/QiyehuoAdmin";
import { filterKeywordOptions } from '../../lib/cascaderUtils.js';
import PhoneCom from "common/PhoneCom";

export default {
  name: "Speed",
  mixins: [fscDate],
  components: {
    CallLogs,
    OrderInfo,
    WxWorkChat,
    PhoneCom
  },
  data() {
    return {
      activeOpen: "",
      info_excel: null,
      serviceCheckType: this.$feedBackConfig.order_service,
      reason_for_fail_show: false,
      reason_for_fail: "",
      wxChatDrawer: false,
      wxWorkChatId: "",
      wxWorkchatCompany: "",
      needSendId: "",
      need_customer_phone: "",
      dispatch: "",
      importNum: "",
      updatedBusinessNum: "",
      dialogFormVisible: false,
      needSum: 0,
      headerCount: [],
      realType: "",
      fromOptions: [],
      meals: [],
      uploadHeader: { Authorization: localStorage.token },
      imgPath: this.$store.state.imgPath,
      counts: {
        total: 0,
        in_service: 0,
        service_complete: 0,
        verifierCount: 0,
        declareCount: 0,
        signatoryCount: 0,
        licenseCount: 0,
        chapterCount: 0,
        materialCount: 0,
      },
      orders: [],
      personnel: [],
      features: [],
      orderRegs: [],
      regTypes: [],
      col: [
        {
          label: "服务人员",
          prop: "operator_name",
        },
        {
          label: "客户姓名",
          prop: "customer_name",
        },
        {
          label: "客户手机",
          prop: "customer_phone",
          width: 170
        },
        {
          label: "法人姓名",
          prop: "corporate_name",
        },
        {
          label: "法人手机",
          prop: "corporate_phone",
          width: 170
        },
        {
          label: "核名时间",
          prop: "verifier_at",
        },
        {
          label: "核名人",
          prop: "verifier_name",
        },
        {
          label: "公司名称",
          prop: "company",
          width: 150
        },
        {
          label: "网报时间",
          prop: "declare_at",
        },
        {
          label: "网报人",
          prop: "declarer_name",
        },
        {
          label: "网签时间",
          prop: "signatory_at",
        },
        {
          label: "网签人",
          prop: "signatory_name",
        },
        {
          label: "执照领取时间",
          prop: "license_at",
        },
        {
          label: "执照领取人",
          prop: "licensee_name",
        },
        {
          label: "是否刻章",
          prop: "chapter",
        },
        {
          label: "刻章时间",
          prop: "chapter_at",
        },
        {
          label: "刻章人",
          prop: "chapter_name",
        },
        {
          label: "材料交接时间",
          prop: "material_at",
        },
        {
          label: "材料交接人",
          prop: "material_name",
        },
      ],
      search: "",
      RealTypeList: [],
      searchArr: {
        realType: "",
        order_num: "",
        service_status: "",
        consultant: null,
        handNode: null,
        feature: null,
        actual_reg_type: null,
        operator: null,
        platform: null,
        park: null,
        verifier_at: null,
        declare_at: null,
        signatory_at: null,
        license_at: null,
        material_at: null,
        verification_state: null,
        company_id: null,
        dispatchDate: "",
        hasConductFile: null
      },
      pageOption: {
        total: 0,
        currentPage: 1, // 当前页数
        searchCurrentPage: 1, // 搜索后页码
        pageSize: 30, // 每页显示条数
      },
      conductForm: {
        index: null,
        id: 0,
        doc_status: null,
        docHandleRecord: [],
        verifier: "",
        verifier_at: "",
        verification_company_name: null,
        verification_state: "未通过",
        company: null,
        company_id: null,
        declarer: "",
        declare_at: "",
        signatory: "",
        signatory_at: "",
        licensee: "",
        license_at: "",
        chapter: "否",
        chapter_pr: "",
        chapter_at: "",
        order_status: "",
        service_status: "",
        material: null,
        material_at: "",
        area: null,
        park: null,
        com_doc_url: null,
        organizer_at: "",
        organizer_name: "",
        customer_phone: "",
        established_at: "",
      },
      conductDrawer: false,
      conductFileList: [],
      materialFlieList: [],
      inputSize: "small",
      activeName: "info",
      areas: [],
      parks: [],
      changeParks: [],
      companies: [],
      loading: false,
      orderNumChange: false,
      callLogsDrawer: false,
      company: "",
      callPhone: [],
      callPhone1: [],
      callPhone2: [],
      callPhone3: [],
      orderInfoVisible: false,
      orderInfoId: null,
      searchLoading: false,
      searchCompanies: [],
      feiShuDocVisible: false,
      out_trade_num: ''
    };
  },
  computed: {
    actionHost: {
      get: function () {
        return process.env.NODE_ENV === "development" ? "" : "https://weixin.qiyehuo.com";
      },
    },
    searchStr: function () {
      let str = "";
      for (let key in this.searchArr) {
        str += "&" + key + "=" + this.searchArr[key];
      }

      return str;
    },
    HeaderList: function () {
      var sum = 0;
      var arr = [];
      // var needArr = [this.headerCount]
      // needArr.map(item => {
      //   var k = Object.keys(item)
      //   console.log(k)
      //   var needkey = k.indexOf('ysytype')
      //   console.log(needkey)
      //   if (needkey !== -1) {
      //     arr.push(item)
      //     sum += item[k[needkey]]
      //   }
      // })
      for (let key in this.headerCount) {
        if (key.indexOf("ysytype") !== -1) {
          sum += this.headerCount[key];
          var newKey = key.split("ysytype")[1];
          arr.push({ [newKey]: this.headerCount[key] });
          // console.log(newKey)
          // var str = newKey + ':' + this.headerCount[key]
          // arr.push({newKey: this.headerCount[key]})
        }
      }
      console.log(arr);
      console.log(sum);
      return [arr, sum];
    },
    typeInPickerOptions: function () {
      var _this = this;
      return {
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              const todayDate = new Date().toLocaleDateString();
              var dateArr = _this.nowDate(todayDate);
              const start = new Date(dateArr[0], dateArr[1] - 1, dateArr[2], 0, 0, 0);
              const end = new Date(dateArr[0], dateArr[1] - 1, dateArr[2], 23, 59, 59);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "昨天",
            onClick(picker) {
              const dd = new Date();
              dd.setDate(dd.getDate() - 1);
              var yesterDate = dd.toLocaleDateString();
              var dateArr = _this.nowDate(yesterDate);
              const start = new Date(dateArr[0], dateArr[1] - 1, dateArr[2], 0, 0, 0);
              const end = new Date(dateArr[0], dateArr[1] - 1, dateArr[2], 23, 59, 59);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "本周",
            onClick(picker) {
              var now = new Date();
              const year = now.getFullYear();
              const month = now.getMonth();
              const day = now.getDate();
              const week = now.getDay();

              let start = new Date(year, month, day - week + 1, 0, 0, 0);
              let end = new Date(year, month, day - week + 7, 23, 59, 59);

              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "上周",
            onClick(picker) {
              var dateS = _this.getWeek(-1, 0).split("-");
              var dateE = _this.getWeek(-1, 1).split("-");

              let start = new Date(dateS[0], dateS[1] - 1, dateS[2], 0, 0, 0);
              let end = new Date(dateE[0], dateE[1] - 1, dateE[2], 23, 59, 59);

              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "本月",
            onClick(picker) {
              var str = _this.getCurrentDate();

              var arr = _this.getfirstDateAndlastDate(str);

              var arrS = arr[0].split("-");
              var arrE = arr[1].split("-");

              var start = new Date(arrS[0], arrS[1] - 1, arrS[2], 0, 0, 0);
              var end = new Date(arrE[0], arrE[1] - 1, arrE[2], 23, 59, 59);

              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "上个月",
            onClick(picker) {
              var str = _this.fromLastMonth();

              var arr = _this.getfirstDateAndlastDate(str);

              var arrS = arr[0].split("-");
              var arrE = arr[1].split("-");

              var start = new Date(arrS[0], arrS[1] - 1, arrS[2], 0, 0, 0);
              var end = new Date(arrE[0], arrE[1] - 1, arrE[2], 23, 59, 59);

              picker.$emit("pick", [start, end]);
            },
          },
        ],
      };
    },
    collapse() {
      return this.$store.state.collapse;
    },
  },
  methods: {
    highlightQualify(content) {
      let match = "合格";
      let highlighted = content.replace(
        match,
        `<span style="color: #67c23a !important;">${match}</span>`
      );
      return highlighted;
    },
    // 信息表检查
    SaveChangeMethods(id, field, title_name) {
      // console.log(this.info_excel);return;
      if (this.info_excel === "合格") {
        this.reason_for_fail_show = false;
        this.$confirm("确定当前信息表是合格吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.$axios
              .post("api/admin/schedule/update_info_excel_status", {
                info_excel: this.info_excel,
                field: field,
                title_name: title_name,
                id: id,
              })
              .then(({ data }) => {
                if (data.code === 0) {
                  // let index = this.conductForm.index
                  this.conductForm[field] = 1;
                  // this.orders[index][field] = 1
                  this.conductForm.docHandleRecord = data.data.infoExcelLogs;
                  // this.orders[index]['info_excel_log'] = this.orders[index]['info_excel_log'].unshift(...data.data.infoExcelLogs)
                  this.handelGetOrders();
                  this.$message.success(data.msg);
                } else {
                  this.$message.error(data.msg);
                }
              })
              .catch();
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消",
            });
            this.info_excel = null;
          });
      } else {
        this.reason_for_fail_show = true;
      }
    },
    handleUpdateDocStatus(id, field, consultant) {
      if (this.reason_for_fail === "") {
        this.$message.error("请填写不合格原因~");
        return;
      }
      this.$axios
        .post("api/admin/schedule/update_info_excel_status", {
          reason_for_fail: this.reason_for_fail,
          id: id,
          info_excel: this.info_excel,
          consultant: consultant,
        })
        .then(({ data }) => {
          if (data.code === 0) {
            let index = this.conductForm.index;
            this.conductForm[field] = 2;
            // this.orders[index][field] = 2
            this.conductForm.docHandleRecord = data.data.infoExcelLogs;
            // this.orders[index]['info_excel_log'] = this.orders[index]['info_excel_log'].unshift(...data.data.infoExcelLogs)
            this.handelGetOrders();
            this.$message.success(data.msg);
          } else {
            this.$message.error(data.msg);
          }
        })
        .catch();
    },
    handleWxChatBeforeClose(done) {
      this.wxWorkChatId = "";
      this.wxWorkchatCompany = "";
      done();
    },
    handleWxChatOpen(chat, companyName) {
      if (chat) {
        this.wxChatDrawer = true;
        setTimeout(() => {
          this.wxWorkChatId = chat.chat_id;
          this.wxWorkchatCompany = companyName;
        });
      }
    },
    sendMessage_complete() {
      if (this.conductForm.service_status === "服务完成") {
        this.doSend("完成");
      }
    },
    sendMessage_material() {
      if (this.conductForm.material && this.conductForm.material_at) {
        this.doSend("材料交接");
      }
    },
    sendMessage_passport() {
      if (
        this.conductForm.licensee &&
        this.conductForm.license_at &&
        this.conductForm.company_id
      ) {
        this.doSend("执照");
      }
    },
    sendMessage_net() {
      if (this.conductForm.signatory_at && this.conductForm.signatory) {
        this.doSend("网签");
      }
    },
    sendMessage_verify() {
      if (
        this.conductForm.verification_company_name &&
        this.conductForm.verifier &&
        this.conductForm.verifier_at &&
        this.conductForm.verification_state === "通过"
      ) {
        this.doSend("核名");
      }
    },
    sendMessage() {
      if (
        this.conductForm.declarer &&
        this.conductForm.park &&
        this.conductForm.area &&
        this.conductForm.declare_at
      ) {
        this.doSend("网报");
      }
    },
    doSend(pro) {
      // 暂时取消通知
      // if (!this.need_customer_phone) return false;
      // this.$axios
      //   .get("api/other_orders/speeds/send_net_report", {
      //     params: {
      //       customerPhone: this.need_customer_phone,
      //       pro,
      //       id: this.needSendId,
      //     },
      //   })
      //   .then(({ data }) => {
      //     if (data.code === 1) {
      //       this.$message.success(data.msg);
      //     }
      //   })
      //   .catch();
    },
    // 复制功能
    copy(data) {
      // 存储传递过来的数据
      let OrderNumber = data;
      // 创建一个input 元素
      // createElement() 方法通过指定名称创建一个元素
      let newInput = document.createElement("input");
      // 讲存储的数据赋值给input的value值
      newInput.value = OrderNumber;
      // appendChild() 方法向节点添加最后一个子节点。
      document.body.appendChild(newInput);
      // 选中input元素中的文本
      // select() 方法用于选择该元素中的文本。
      newInput.select();
      // 执行浏览器复制命令
      //  execCommand方法是执行一个对当前文档，当前选择或者给出范围的命令
      document.execCommand("Copy");
      // 清空输入框
      newInput.remove();
      // 下面是element的弹窗 不需要的自行删除就好
      this.$message({
        message: "复制成功",
        type: "success",
      });
    },
    copySome(data) {
      this.copy(data);
    },
    exportTableData() {
      this.$axios
        .post("api/schedule/export", this.searchStr, { responseType: "blob" })
        .then(({ data }) => {
          let blob = new Blob([data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          let objectUrl = window.URL.createObjectURL(blob);
          let link = document.createElement("a");
          link.href = objectUrl;
          link.download = "公司注册进度.xlsx";
          link.click();
          setTimeout(function () {
            window.URL.revokeObjectURL(objectUrl);
          }, 10);
        })
        .catch();
    },
    goToGetResult(val) {
      this.searchArr.dispatchDate = val;
    },
    nowDate(date) {
      return date.split("/");
    },
    getWeek(n, type) {
      // 周
      let now = new Date();
      let day = now.getDay(); // 返回星期几的某一天;
      if (!type) {
        if (n === 1) {
          let dayNumber = day === 0 ? 0 : 7 - day;
          now.setDate(now.getDate() + dayNumber + 1);
        } else if (n === -1) {
          let dayNumber = day === 0 ? 6 : day - 1;
          now.setDate(now.getDate() - dayNumber - 7);
        } else {
          let dayNumber = day === 0 ? 6 : day - 1;
          now.setDate(now.getDate() - dayNumber);
        }
      } else {
        if (n === 1) {
          let dayNumber = day === 0 ? 0 : 7 - day;
          now.setDate(now.getDate() + dayNumber + 1 + 6); // 在周开始的日期上+6天=周结束
        } else if (n === -1) {
          let dayNumber = day === 0 ? 6 : day - 1;
          now.setDate(now.getDate() - dayNumber - 7 + 6);
        } else {
          let dayNumber = day === 0 ? 0 : 7 - day;
          now.setDate(now.getDate() + dayNumber);
        }
      }
      let date = now.getDate();
      let month = now.getMonth() + 1;

      let s =
        now.getFullYear() +
        "-" +
        (month < 10 ? "0" + month : month) +
        "-" +
        (date < 10 ? "0" + date : date);
      return s;
    },
    getfirstDateAndlastDate(dateC) {
      var dateStr = dateC;
      var date = new Date(dateStr);
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      if (month > 12) {
        month = 1;
        year++;
      }
      if (month < 10) {
        month = "0" + month;
      }
      var monthLastDay = new Date(year, month, 0).getDate();
      var firstDate = year + "-" + month + "-" + "01";
      var lastDate = year + "-" + month + "-" + monthLastDay;
      return [firstDate, lastDate];
    },
    getCurrentDate() {
      var date = new Date();
      var seperator1 = "-";
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      var currentdate = year + seperator1 + month + seperator1 + strDate;
      return currentdate;
    },
    fromLastMonth() {
      var date = new Date();
      var lastMonthDate = "";
      // 获取当前几号，如果小于10则补0
      var day = date.getDate();
      if (day < 10) {
        day = "0" + day;
      }
      var month = date.getMonth();
      var year = date.getFullYear();
      // 上个月小于1则证明跨年，年份减1
      if (month < 1) {
        lastMonthDate = year - 1 + "-12-" + day;
      } else {
        // 月份小于10则补0
        if (month < 10) {
          month = "0" + month;
        }
        lastMonthDate = year + "-" + month + "-" + day;
      }
      return lastMonthDate;
    },
    findAdviserUpdateToBusiness() {
      this.$axios
        .get("api/admin/other_orders/find_adviser_updateto_buiness")
        .then(({ data }) => {
          if (data.code === 1) {
            this.importNum = data.total;
            this.updatedBusinessNum = data.data;
            this.dialogFormVisible = true;
          }
        })
        .catch();
    },
    handelGetOrders() {
      this.$axios
        .get(
          "/api/admin/other_orders/speeds?page=" +
            this.pageOption.currentPage +
            "&pageSize=" +
            this.pageOption.pageSize +
            this.searchStr
        )
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            this.orders = data.data.orders.data;
            this.pageOption.total = data.data.orders.total;
            this.headerCount = data.data.counts;
            this.counts.in_service = data.data.counts.in_service;
            this.counts.service_complete = data.data.counts.service_complete;
            this.counts.verifierCount = data.data.counts.verifierCount;
            this.counts.declareCount = data.data.counts.declareCount;
            this.counts.signatoryCount = data.data.counts.signatoryCount;
            this.counts.licenseCount = data.data.counts.licenseCount;
            this.counts.chapterCount = data.data.counts.chapterCount;
            this.counts.materialCount = data.data.counts.materialCount;

            this.personnel = data.data.personnel;
            this.features = data.data.features;
            this.meals = data.data.meals;
            this.orderRegs = data.data.orderRegs;
            this.regTypes = data.data.regTypes;
            this.areas = data.data.areas;
            this.parks = data.data.parks;
            this.orderNumChange = false;
          }
        });
    },
    handleOrderNumChange(val) {
      if (this.orderNumChange) return;
      this.orderNumChange = true;
      setTimeout(() => {
        this.pageOption.currentPage = 1;
        this.handelGetOrders();
      }, 800);
    },
    handleSizeChange(val) {
      this.pageOption.pageSize = val;
      this.handelGetOrders();
    },
    handleCurrentChange(val) {
      this.pageOption.currentPage = val;
      this.handelGetOrders();
    },
    handleASearSub() {
      this.pageOption.currentPage = 1;
      this.activeOpen = "";
      this.handelGetOrders();
    },
    handleASearClear() {
      this.activeOpen = "";
      this.$axios.get("/api/admin/other_orders/speeds/searchClear").then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.orders = data.data.orders;
          this.pageOption.total = this.orders.length;
          this.counts.total = data.data.counts.total;
          this.counts.in_service = data.data.counts.in_service;
          this.counts.service_complete = data.data.counts.service_complete;
          this.counts.verifierCount = data.data.counts.verifierCount;
          this.counts.declareCount = data.data.counts.declareCount;
          this.counts.signatoryCount = data.data.counts.signatoryCount;
          this.counts.licenseCount = data.data.counts.licenseCount;
          this.counts.chapterCount = data.data.counts.chapterCount;
          this.counts.materialCount = data.data.counts.materialCount;
          this.$nextTick(() => {
            this.clearSearch();
          })
        }
      });
    },
    clearSearch() {
      this.searchArr.orderNum = "";
      this.searchArr.service_status = "";
      this.searchArr.consultant = null;
      this.searchArr.handNode = null;
      this.searchArr.feature = null;
      this.searchArr.actual_reg_type = null;
      this.searchArr.operator = null;
      this.searchArr.platform = null;
      this.searchArr.park = null;
      this.searchArr.verifier_at = null;
      this.searchArr.declare_at = null;
      this.searchArr.signatory_at = null;
      this.searchArr.license_at = null;
      this.searchArr.material_at = null;
      this.searchArr.verification_state = null;
      this.searchArr.company_id = null;
      this.searchArr.realType = "";
      this.searchArr.dispatchDate = "";
      this.searchArr.hasConductFile = null;
      this.dispatch = "";
      this.pageOption.currentPage = 1;
      this.pageOption.searchCurrentPage = 1;
    },
    handleConduct(index, row) {
      // console.log(row);
      this.need_customer_phone = row.customer_phone;
      this.needSendId = row.id;
      this.conductForm.index = index;
      this.conductForm.id = row.id;
      this.conductForm.doc_status = row.doc_status;
      this.conductForm.docHandleRecord = row.info_excel_log;
      this.conductForm.verifier = row.verifier;
      this.conductForm.verifier_at = row.verifier_at;
      this.conductForm.verification_company_name = row.verification_company_name;
      this.conductForm.verification_state = row.verification_state;
      this.conductForm.company = row.company;
      this.conductForm.company_id = row.company_id;
      if (row.company_id && row.company) {
        this.companies.push({ id: row.company_id, company_name: row.company });
      }
      this.conductForm.declarer = row.declarer;
      this.conductForm.declare_at = row.declare_at;
      this.conductForm.signatory = row.signatory;
      this.conductForm.signatory_at = row.signatory_at;
      this.conductForm.licensee = row.licensee;
      this.conductForm.license_at = row.license_at;
      this.conductForm.established_at = row.company_obj
        ? row.company_obj.date_of_est
        : "";
      this.conductForm.material = row.material;
      this.conductForm.material_at = row.material_at;
      this.conductFileList = row.conduct_annexes;
      this.materialFlieList = row.material_annexes;
      this.conductForm.chapter = row.chapter;
      this.conductForm.chapter_pr = row.chapter_pr;
      this.conductForm.chapter_at = row.chapter_at;
      this.conductForm.order_status = row.order_status;
      this.conductForm.service_status = row.service_status;
      this.conductForm.area = row.area;
      this.handleAreaChange(row.area);
      this.conductForm.park = row.park;
      this.conductForm.com_doc_url = row.com_doc_url;
      this.conductForm.organizer_name = row.organizer_name;
      this.conductForm.organizer_at = row.organizer_at;
      this.conductForm.customer_phone = row.customer_phone;
      this.getRealType(row.actual_reg_type);
      this.out_trade_num = row.order_num;
      this.conductDrawer = true;
    },
    getRealType(id) {
      if (!id) return false;
      this.$axios
        .get("api/admin/tycOrders/real_type?type=" + id)
        .then(({ data }) => {
          if (data.code === 1) {
            this.realType = data.data;
          }
        })
        .catch();
    },
    getRealTypeList() {
      this.$axios
        .get("api/admin/tycOrders/get_real_list")
        .then(({ data }) => {
          if (data.code === 1) {
            this.RealTypeList = data.data;
          }
        })
        .catch();
    },
    handleConductClose(done) {
      this.clearConductData();
      done();
    },
    clearConductData() {
      this.info_excel = null;
      this.reason_for_fail = "";
      this.reason_for_fail_show = false;
      this.needSendId = "";
      this.need_customer_phone = "";
      this.realType = "";
      this.conductForm.index = null;
      this.conductForm.id = 0;
      this.conductForm.doc_status = null;
      this.conductForm.docHandleRecord = [];
      this.conductForm.verifier = "";
      this.conductForm.verifier_at = "";
      this.conductForm.verification_company_name = null;
      this.conductForm.verification_state = "未通过";
      this.conductForm.company = null;
      this.conductForm.company_id = null;
      this.conductForm.declarer = "";
      this.conductForm.declare_at = "";
      this.conductForm.signatory = "";
      this.conductForm.signatory_at = "";
      this.conductForm.licensee = "";
      this.conductForm.license_at = "";
      this.conductForm.established_at = "";
      this.conductForm.chapter = "否";
      this.conductForm.chapter_pr = "";
      this.conductForm.chapter_at = "";
      this.conductForm.material = null;
      this.conductForm.material_at = "";
      this.conductFileList = [];
      this.materialFlieList = [];
      this.conductForm.order_status = "";
      this.conductForm.service_status = "";
      this.conductForm.area = null;
      this.conductForm.park = null;
      this.conductForm.com_doc_url = null;
      this.conductForm.organizer_name = "";
      this.conductForm.organizer_at = "";
      this.conductForm.customer_phone = "";
      this.companies = [];
    },
    handleConductChange(field, fieldName, customerPhone = "") {
      if (field === "verification_company_name") this.sendMessage_verify();
      let index = this.conductForm.index;
      if (this.orders[index][field] === this.conductForm[field]) return;
      this.$axios
        .put("/api/admin/tyc_orders/field/" + this.conductForm.id, {
          field: String(field),
          fieldName: fieldName,
          value: this.conductForm[field],
          old: this.orders[index][field],
          customerPhone: customerPhone,
        })
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            this.orders[index][field] = this.conductForm[field];
            if (field === "established_at") {
              this.orders[index]["company_obj"]["date_of_est"] = this.conductForm[field];
            }
            this.$message.success(data.msg);
          } else {
            this.$message.error(data.msg);
          }
        });
    },
    handelPeople(field, relatedField, fieldName, type) {
      // console.log(111)
      if (field === "verifier") this.sendMessage_verify();
      if (field === "declarer") this.sendMessage();
      if (field === "signatory") this.sendMessage_net();
      if (field === "licensee") this.sendMessage_passport();
      if (field === "material") this.sendMessage_material();
      let index = this[type].index;
      let name = this.getPeopleName(this[type][field]);
      let old = this.getPeopleName(this.orders[index][field]);

      // console.log(name)
      // console.log(old)

      if (name === old) return;

      this.handelPeopleChange(field, relatedField, fieldName, type, index, name, old);
    },
    getPeopleName(val) {
      // let obj = {};
      let name = "";
      // obj = this.personnel.find((item) => {
      //   return item.value === val;
      // });

      let obj = this.findValue(val);

      if (obj) name = obj.label;

      return name;
    },
    findValue(val) {
      let obj = null;
      outerLoop: for (let item of this.personnel) {
        for (let child of item.children) {
          if (child.value === val) {
            obj = child;
            break outerLoop; // 在找到匹配值后跳出外部循环
          }
        }
      }
      return obj;
    },
    handelPeopleChange(field, relatedField, fieldName, type, index, name, old) {
      let params = {
        field: String(field),
        relatedField: relatedField,
        fieldName: fieldName,
        value: this[type][field],
        name: name,
        old: old,
      };

      this.$axios
        .put("/api/admin/tyc_orders/people/" + this[type].id, params)
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            this.orders[index][field] = this[type][field];
            this.orders[index][relatedField] = name;
            this.$message.success(data.msg);
          } else {
            this.$message.error(data.msg);
          }
        });
    },
    handelPickerChange(field, fieldName) {
      if (field === "verifier_at") this.sendMessage_verify();
      if (field === "declare_at") this.sendMessage();
      if (field === "signatory_at") this.sendMessage_net();
      if (field === "license_at") this.sendMessage_passport();
      if (field === "material_at") this.sendMessage_material();
      this.handleConductChange(field, fieldName);
    },
    handleConductAnnexSuccess(res, file) {
      if (res.code === 0) {
        this.conductFileList.push({
          id: res.data.id,
          name: file.name,
          url: this.imgPath + res.data.store_result,
        });
      } else {
        this.$message.error(res.msg);
      }
    },
    handleConductPreview(file) {
      var tempwindow = window.open("_blank");
      tempwindow.location = file.url;
    },
    handleConductRemove(file, fileList) {
      this.$axios.delete("/api/admin/tyc_annex/" + file.id).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          let index = this.conductForm.index;
          this.conductFileList = fileList;
          this.orders[index].conduct_annexes = fileList;
          this.$message.success(data.msg);
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    handleMaterialSuccess(res, file) {
      if (res.code === 0) {
        this.materialFlieList.push({
          id: res.data.id,
          name: file.name,
          url: this.imgPath + res.data.store_result,
        });
      } else {
        this.$message.error(res.msg);
      }
    },
    handleMaterialPreview(file) {
      var tempwindow = window.open("_blank");
      tempwindow.location = file.url;
    },
    handleMaterialRemove(file, fileList) {
      this.$axios.delete("/api/admin/tyc_annex/" + file.id).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          let index = this.conductForm.index;
          this.materialFlieList = fileList;
          this.orders[index].material_annexes = fileList;
          this.$message.success(data.msg);
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    handleConductComplete() {
      let index = this.conductForm.index;
      if (!this.orders[index].corporate_name) {
        this.$message.error("请先完善法人姓名");
        return;
      }
      if (!this.orders[index].corporate_phone) {
        this.$message.error("请先完善法人手机号");
        return;
      }
      this.conductForm.service_status = "服务完成";
      this.$nextTick(() => {
        this.sendMessage_complete();
      });
      this.handleConductChange("service_status", "办理进度");
    },
    getOrderRegTypeName(val) {
      let obj = {};
      let name = "";
      obj = this.orderRegs.find((item) => {
        return item.order_reg_id === val;
      });
      if (obj) name = obj.order_reg_name;
      return name;
    },
    copyUrl(data) {
      let url = data;
      let oInput = document.createElement("input");
      oInput.value = url;
      document.body.appendChild(oInput);
      oInput.select(); // 选择对象;
      // console.log(oInput.value)
      document.execCommand("Copy"); // 执行浏览器复制命令
      this.$message({
        message: "已成功复制到剪切板",
        type: "success",
      });
      oInput.remove();
    },
    handleAreaSub(field, fieldName, type) {
      if (this.conductForm.area) this.sendMessage();
      let index = this[type].index;
      let name = this.getAreaName(this[type][field]);
      let old = this.getAreaName(this.orders[index][field]);

      // if (name === old) return

      this.handelSelSub(field, fieldName, type, index, name, old);
      this.handleAreaChange(this[type][field]);
    },
    handleAreaChange(val) {
      this.changeParks = [];
      this.conductForm.park = null;

      for (var i = 0; i < this.parks.length; i++) {
        if (this.parks[i].pid === val) {
          this.changeParks.push(this.parks[i]);
        }
      }
    },
    getAreaName(val) {
      let obj = {};
      let name = "";
      obj = this.areas.find((item) => {
        return item.id === val;
      });
      if (obj) name = obj.areaName;
      return name;
    },
    handleParkChange(field, fieldName, type) {
      if (this.conductForm.park) this.sendMessage();
      let index = this[type].index;
      let name = this.getParkName(this[type][field]);
      let old = this.getParkName(this.orders[index][field]);

      this.handelSelSub(field, fieldName, type, index, name, old);
    },
    getParkName(val) {
      let obj = {};
      let name = "";
      obj = this.parks.find((item) => {
        return item.id === val;
      });
      if (obj) name = obj.areaName;
      return name;
    },
    handelSelSub(field, fieldName, type, index, name, old) {
      let params = {
        field: String(field),
        fieldName: fieldName,
        value: this[type][field],
        nameStr: name,
        oldStr: old,
      };

      this.$axios
        .put("/api/admin/tyc_orders/sel/" + this[type].id, params)
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            this.orders[index][field] = this[type][field];
            if (field === "actual_reg_type") {
              this.orders[index].reg_type = {
                reg_type_id: this[type][field],
                reg_type_name: name,
              };
            }

            if (field === "order_reg_type") {
              this.orders[index].order_reg = {
                order_reg_id: this[type][field],
                order_reg_name: name,
              };
            }

            if (field === "sources") {
              this.orders[index].sources = this[type][field];
              this.orders[index].source = {
                source_id: this[type][field],
                source_name: name,
              };
            }
            this.$message.success(data.msg);
          } else {
            this.$message.error(data.msg);
          }
        });
    },
    remoteMethod(query) {
      if (query !== "") {
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
          this.searchCompanys(query);
        }, 200);
      } else {
        this.companies = [];
      }
    },
    searchCompanys(query) {
      this.$axios.get("/api/admin/searchCompany?name=" + query).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.companies = data.data.companies;
        }
      });
    },
    handleCompanyChange() {
      this.sendMessage_passport();
      let oldName = this.conductForm.company;
      let newName = this.getCompanyName(this.conductForm.company_id);

      this.$axios
        .post("/api/admin/companyChange/" + this.conductForm.id, {
          oldName: oldName,
          newName: newName,
          changeId: this.conductForm.company_id,
        })
        .then((res) => {
          let { data } = res;
          if (data.code === 0) {
            this.$message.success(data.msg);
            this.orders[this.conductForm.index].company = newName;
            this.orders[this.conductForm.index].company_id = this.conductForm.company_id;
          }
        });
    },
    getCompanyName(id) {
      let newName = null;
      for (var i = 0; i < this.companies.length; i++) {
        if (this.companies[i].id === id) {
          newName = this.companies[i].company_name;
        }
      }

      return newName;
    },
    handelSaveChange(field, fieldName) {
      this.sendMessage_verify();
      let index = this.conductForm.index;

      if (this.orders[index][field] === this.conductForm[field]) return;
      this.$axios
        .put("/api/admin/tyc_orders/field/" + this.conductForm.id, {
          field: String(field),
          fieldName: fieldName,
          value: this.conductForm[field],
          old: this.orders[index][field],
        })
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            this.orders[index][field] = this.conductForm[field];
            this.$message.success(data.msg);
          } else {
            this.$message.error(data.msg);
          }
        });
    },
    handCallLogsOpen(row) {
      this.callLogsDrawer = true;
      setTimeout(() => {
        if (row.customer_phone) this.callPhone1.push(row.customer_phone);
        if (row.corporate_phone) this.callPhone2.push(row.corporate_phone);
        if (row.company_obj) {
          this.company = row.company_obj.company_name;
          if (row.company_obj.user) {
            this.callPhone.push(row.company_obj.user.phone);
          }
          if (row.company_obj.docking_phone) {
            this.callPhone3.push(row.company_obj.docking_phone);
          }
        }
      });
    },
    handleCallLogsBeforeClose(done) {
      this.company = "";
      this.callPhone = [];
      this.callPhone1 = [];
      this.callPhone2 = [];
      this.callPhone3 = [];
      done();
    },
    handleOrderInfo(orderId, order_num) {
      this.orderInfoVisible = true;
      setTimeout(() => {
        this.orderInfoId = orderId;
        this.out_trade_num = order_num;
      });
    },
    handleOrderInfoClose(done) {
      this.orderInfoId = null;
      done();
    },
    searchRemoteCompanyMethod(query) {
      if (query !== "") {
        this.searchLoading = true;
        setTimeout(() => {
          this.searchLoading = false;
          this.searchArrItemCompanys(query);
        }, 200);
      } else {
        this.searchCompanies = [];
      }
    },
    searchArrItemCompanys(query) {
      this.$axios.get("/api/admin/searchCompany?name=" + query).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.searchCompanies = data.data.companies;
        }
      });
    },
    handleSearchCompanyChange(val) {
      this.pageOption.currentPage = 1;
      this.handelGetOrders();
    },
    handelAddFeiShuDoc() {
      this.feiShuDocVisible = true;
      console.log(this.conductForm.com_doc_url);
    },
    handelEditFlow() {
      runQiyehuoAdmin((admin) => {
        let orderId = this.conductForm.id;
        console.debug(`QiyehuoAdmin.showCompanyRegistryFlow: ${orderId}`);
        admin.showCompanyRegistryFlow({
          orderId,
        });
      });
    },
    handleShuDocClose(done) {
      done();
    },
    showDoc() {
      let newPage = this.$router.resolve({
        path: "/feishu",
        query: { url: this.conductForm.com_doc_url, oid: this.conductForm.id },
      });
      window.open(newPage.href, "_blank");
    },
    getFrom() {
      this.$axios
        .get("api/admin/other_orders/get_froms")
        .then(({ data }) => {
          if (data.code === 1) {
            this.fromOptions = data.data;
          }
        })
        .catch();
    },
    handleClickCollapseOutSide(event) {
      const elCollapse = this.$el.querySelector('.el-collapse');
      if (elCollapse && !elCollapse.contains(event.target)) {
        this.activeOpen = '';
      }
    },
    filterOptions(node, keyword) {
  return filterKeywordOptions(node, keyword);
}
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickCollapseOutSide);
  },
  mounted() {
    this.handelGetOrders();
    document.addEventListener('click', this.handleClickCollapseOutSide);
  },
};
</script>

<style lang="stylus" scoped>
@import '~styles/varibles.styl';
@import '~styles/vertical.styl';

[v-cloak] {
  display: none;
}

.custom-link {
  text-decoration: underline;
}

.check-succ {
  color: #67C23A;
}

.setBadge >>> .el-badge__content.is-fixed {
  top: 0.22rem;
  right: 0.06rem;
}

.el-drawer__wrapper >>> .el-drawer {
  overflow-y: auto;
}

.schedule >>> .el-drawer__header {
  font-size: 0.36rem;
  font-weight: 400;
  color: #4D84FE;
}

.schedule >>> .el-table__header th {
  color: #333333;
}

.schedule >>> .el-timeline-item__node--normal {
  left: 0;
  background-color: #ECF4FF;
}

.el-select, .el-cascader {
  width: 100%;
}

.schedule {
  marginLeft();
  max-height: 100vh;
  .header-style {
    z-index: 2;
    height: 173px !important;
    padding: 0px !important;
  }
  .main-style {
    z-index: 1;
    padding: 0px !important;
    // overflow-y: auto;
  }
  .footer-style {
    text-align: right;
    .el-pagination {
      padding-top: 15px;
    }
  }
  .count-style {
    display: inherit;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.clearfix:before, .clearfix:after {
  display: table;
  content: '';
}

.clearfix:after {
  clear: both;
}

.search-row .el-col {
  margin-bottom: 0.2rem;
}

.count {
  padding-left: 0.2rem;
  line-height: 0.56rem;
}

.el-collapse {
  border-bottom: 0;
  border-top: 0;
}

.el-collapse >>> .el-collapse-item__header {
  color: #4C87FC;
  font-weight: bold;
}

.el-collapse >>> .el-collapse-item__arrow {
  color: #4C87FC;
}

.tr {
  text-align: right;
}

.dot {
  display: inline-block;
  width: 0.1rem;
  height: 0.1rem;
  border-radius: 50%;
  margin-right: 0.1rem;
  top: 0;
  left: -0.2rem;
  bottom: 0;
  margin: auto;
}

.qualified-radio >>> .el-radio-button__inner {
  background-color: #67c23a !important;
  color: #fff !important;
}

.noqualified-radio >>> .el-radio-button__inner {
  background-color: #e6a23c !important;
  color: #fff;
}

.highlight{
  color: #67c23a !important;
}

.mt-50 {
  margin-top: 1rem;
}

.mt-10 {
  margin-top: 0.2rem;
}

.mb-10 {
  margin-bottom: 0.2rem;
}

.m-tabs-content {
  padding: 0 0.2rem 0 0.4rem;

  .tabs-title {
    color: #5789F4;
  }

  .m-label {
    line-height: 0.64rem;
  }

  .el-row {
    margin-bottom: 0.4rem;
  }

  .el-date-editor.el-input, .el-date-editor.el-input__inner {
    width: 100%;
  }
}

.el-date-editor {
  width: 100% !important;
}

.ellipsis-link {
  display: inline-block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.AIdrawer .drawer-title {
  background-color: #ecf5ff;
  padding: 10px;
  color: #409EFF;
}
</style>



// WEBPACK FOOTER //
// src/pages/customer/Schedule.vue